import Button, { type ButtonProps } from '@mui/material/Button';
import React from 'react';
import { useFormContext } from '../../form';

interface SubmitProps extends ButtonProps {
  submitting?: boolean;
}

export const SubmitBase = React.forwardRef<HTMLButtonElement, SubmitProps>(
  (props, ref) => {
    const { submitting = false, children = 'Submit', ...restProps } = props;
    return (
      <Button ref={ref} type="submit" loading={submitting} {...restProps}>
        {children}
      </Button>
    );
  },
);

export function SubmitButton(props: SubmitProps) {
  const { submitting = false, ...restProps } = props;
  const { formState } = useFormContext() as {
    formState: { isSubmitting: boolean };
  };
  return (
    <SubmitBase
      submitting={formState.isSubmitting || submitting}
      {...restProps}
    />
  );
}
